import composeInternalLinkURL from '@/utils/composeInternalLinkURL';
import { getSanitizedPageNumberAsURLParameter } from '../../utils';
import { type Page } from '../PaginationItem';
import { StyledLink } from './PaginationItemPage.styles';

interface Props {
  item: Page;
  urlBase: string;
  localization: {
    goToPage: string;
  };
  current: number;
}

const PaginationItemPage = ({ current, item, urlBase, localization }: Props) => {
  const { page } = item;
  const linkURL = composeInternalLinkURL({
    urlChunks: [urlBase, getSanitizedPageNumberAsURLParameter(page)],
  });
  const isActive = page === current;

  if (!linkURL) {
    return null;
  }

  return (
    <li>
      <StyledLink
        aria-current={isActive ? 'page' : undefined}
        aria-label={`${localization.goToPage} ${page}`}
        isActive={isActive}
        to={linkURL}
      >
        {page}
      </StyledLink>
    </li>
  );
};

export default PaginationItemPage;
